// extracted by mini-css-extract-plugin
export var main_container = "TextSectionCafetera-module--main_container--d8a9c";
export var section2 = "TextSectionCafetera-module--section2--42247";